<template>
	<div>
		<h2 class="heading-4 mb-100">{{ heading }}</h2>
		<OfferingCard v-for="fund in funds" :key="fund.fundriseId" :offering="fund" />
	</div>
</template>

<script setup lang="ts">
import { Asset } from 'types/assets';
import { computed } from 'vue';
import { Fund } from 'types/funds';
import OfferingCard from '@components/offerings/offering-card.vue';
import { pluralize } from '@filters/shared-filters';

interface Props {
	asset: Asset;
}

const props = defineProps<Props>();

const funds = computed((): Array<Fund> => {
	return props.asset.fundAllocations.map((f) => f.fund);
});

const heading = computed((): string => `Associated ${pluralize(funds.value.length, 'fund')}`);
</script>

<style lang="scss" scoped>
.offering-card {
	max-width: 816px;

	&:first-of-type {
		margin-top: unset;
	}
}
</style>
